module.exports = __webpack_public_path__ + "static/img/recycle (1).f980bee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Flat Icon/recycle (1).png
// module id = fHMI
// module chunks = 47